module.exports = ".card .card-header .card-header-right .card-option {\n  width: 190px;\n  -webkit-transition: unset;\n  transition: unset; }\n\n.card .card-header + .card-block-hid .card-block, .card .card-header + .card-block-hid .card-block-big, .card .card-header + .card-block-hid .card-block-small {\n  padding-top: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/card/card.component.scss
// module id = ./src/app/shared/card/card.component.scss
// module chunks = main